module.exports = __webpack_public_path__ + "img/sample_globe_domain_size.3a191eac.svg";